import { QuestionCircleOutlined } from '@ant-design/icons';
import { useIntl } from '@umijs/max';
import { AvatarDropdown as CoreAvatarDropdown, useShell } from '@zhiyue/core';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

const AvatarDropdown: React.FC = () => {
  const intl = useIntl();
  const {
    shellConfig: { ui },
  } = useShell();

  const items = React.useMemo(
    () =>
      ui.links.help
        ? [
            {
              key: 'help',
              icon: <QuestionCircleOutlined />,
              label: intl.formatMessage({ id: 'component.userMenu.help' }),
              href: ui.links.help,
              target: '_blank' as const,
            },
          ]
        : [],
    [intl, ui.links.help],
  );

  return (
    <CoreAvatarDropdown
      appId={BizAppConfig.appSsoClientId}
      personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
      // 回到工作台、企业管理、开放平台在 app.tsx 的 userMenu 中置空隐藏，这里不要再传地址
      items={items}
      // 传入 items 时 core 默认会丢弃个人中心、切换企业、退出登录等默认项
      mergeDefaultItems
    />
  );
};

export default AvatarDropdown;
